export default {
  "component": {
    "tradeInProcess": {
      "649f8aefats0": "Order verlopen",
      "649f8aefc1c0": "Recycling mislukt",
      "649f8aefc9c0": "Ontvang een nieuwe offerte",
      "TradeIn": "Inruilproces",
      "logistic": "Download verzendlabel",
      "start": "Begin je traject",
      "success": "Je hebt het nieuwe toestel succesvol ontvangen",
      "qc": "Kwaliteitscontrole oud toestel",
      "business": "We ronden de inspectie van je oude toestel binnen 3 werkdagen af",
      "completed": "Voltooid",
      "successfully": "Gefeliciteerd, je inruil is succesvol afgerond",
      "orderInfor": "Bestelinformatie",
      "orderID": "Inruil-order-ID",
      "orderNum": "Order-ID van nieuwe aankoop",
      "createTime": "Aanmaakdatum",
      "brand": "Geschat merk",
      "model": "Geschat model",
      "price": "Waarde van oud toestel",
      "bonus": "Bonus",
      "reclaimFailure": "Omdat je het toestel niet binnen 10 dagen hebt verzonden, is de recycling-order verlopen en geannuleerd. Als je de recycling toch wilt afronden, klik dan op de knop hieronder voor de meest recente offerte.",
      "total": "Totale prijs",
      "logisticInfo": "Logistieke informatie",
      "available": "Geen logistieke informatie beschikbaar",
      "logisticNum": "Logistiek nummer",
      "failRey": "Het spijt ons dat je deelname aan het OnePlus-recyclingprogramma niet succesvol is voltooid. Heb je plannen om andere elektronische apparaten te recyclen? Klik dan hieronder voor een snelle waardeschatting!",
      "userRes": "De gebruiker heeft het aanbod al geweigerd.",
      "successPrice": "De volgende prijs is vastgesteld na professionele inspectie. Als je akkoord gaat met deze prijs, wordt de inruil voortgezet. Als je weigert, wordt het toestel binnen enkele werkdagen naar je teruggestuurd.",
      "sure": "Accepteren",
      "Reject": "Weigeren",
      "congratulation": "Gefeliciteerd — geen verschil gevonden bij de kwaliteitscontrole.",
      "finPirce": "Eindprijs",
      "copySuccess": "Kopiëren geslaagd",
      "copyfail": "Kopiëren mislukt",
      "sureSuccess": "Bevestig geslaagde transactie",
      "submitError": "Inzending mislukt",
      "detectionResult": "Detectieresultaat",
      "Collected": "Plaats een bestelling",
      "inTransit": "Onderweg",
      "656g0lj3sav6": "Recyclingproces",
      "656g0lj3cd5a": "Vul je persoonlijke gegevens correct in om de bestelling succesvol te plaatsen",
      "656g0lj3dr9a": "De inspectie van je telefoon wordt binnen 48 uur na ontvangst in ons centrum afgerond",
      "656g0lj3epal": "Zodra de inspectie is afgerond, nemen we via e-mail contact met je op met het eindbod",
      "656g0lj3pda2": "Jouw schatting",
      "656g0lj3ed3d": "Professionele kwaliteitscontrole",
      "656g0lj3esf3": "Kopieer",
      "expertDiscount": "Promotiecode",
      "invalidCode": "Ongeldige code",
      "toastTip": "Vink aan om het Privacybeleid en de Voorwaarden te accepteren.",
      "649f8aef26sf": "Inruilproces",
      "checkTitle": "Testinformatie",
      "basicInformation": "Basisinformatie",
      "understand": "Ik begrijp het"
    },
    "btnDialog": {
      "64a9shqq2ks0": "Weiger recycling",
      "64a9shqq3k00": "Je bevestigt dat je de recycling weigert",
      "64a9shqq3r00": "Annulering geslaagd",
      "64a9shqq3ws0": "Annulering mislukt",
      "sureCancel": "Bevestig annulering"
    }
  },

  "home": {
    "whoAreWe": {
      "646u995ltgw0": "Wie",
      "646u995lv9g0": "zijn wij?",
      "646u9d5lv9g0": "Danghuan is een bedrijf waarvan de kernactiviteiten gericht zijn op de recycling, verwerking en verkoop van 3C-digitale producten zoals mobiele telefoons, tablets, laptops en horloges. Ons bedrijf zet zich in om de efficiëntie van elektronische recycling te versnellen en de gezonde groei van de tweedehandsmarkt te bevorderen. Momenteel hebben wij officiële strategische samenwerkingen opgebouwd met OPPO, Vivo, OnePlus, Realme en andere merken. Onze internationale activiteiten zijn inmiddels uitgebreid naar India, Thailand, Vietnam, Cambodja en nu ook Europa.",
      "646u995dv9g0": "Onze wereldwijde aanwezigheid maakt ons een strategische partner voor mobiele operators, fabrikanten en groothandelaars met zowel continentale als transcontinentale reikwijdte.",
      "646u99slv9g0": "Wij werken samen met toonaangevende fabrikanten en houden een diverse voorraad aan van lage, midden en hoge klasse apparaten. Zo kunnen wij aangepaste oplossingen en concurrerende prijzen bieden die aansluiten bij de behoeften van onze klanten."
    },
    "business": {
      "646v04syvpk0": "Ben je geïnteresseerd in de aankoop van onze voorraad?",
      "646v04syxs80": "Bij Danghuan bieden we een uitgebreide selectie van smartphones, tablets en smartwatches aan, beschikbaar in verschillende gradaties om aan de diverse behoeften van bedrijven te voldoen.",
      "646v04syy6g0": "Neem contact op met onze Sales & Purchase Manager:",
      "646v04syya80": "Ik wil kopen",
      "646v04syydg0": "Vul je naam in",
      "646v04syyh40": "Vul je telefoonnummer in",
      "646v04syyyw0": "Vul je e-mailadres in",
      "646v0gsyz1s0": "Land:",
      "646v04syz1s0": "Kies een optie",
      "646v04syz4o0": "Ik heb gelezen en ga akkoord met de",
      "646v04syzkc0": "Privacybeleid",
      "646v04syzok0": "Neem contact met ons op",
      "646v04syzvo0": "Voer je telefoonnummer in",
      "646v04syzys0": "Voer je e-mailadres in",
      "646v04sz01o0": "Voer een geldig e-mailadres in",
      "646v04sz04g0": "Voer je naam in",
      "646v04sz0740": "Vink het vakje aan om akkoord te gaan met het privacybeleid",
      "646v04sz0a00": "Inzending geslaagd",
      "646v04sz0cw0": "Inzending mislukt",
      "title1": "Transparante toestelclassificatie",
      "text1-1": "Om je aankoopbeslissing te ondersteunen, raden we je aan ons gedetailleerde beoordelingsdocument te bekijken. Hierin staan de esthetische en functionele normen van elke categorie, zodat je een weloverwogen keuze kunt maken die aansluit bij je verwachtingen.",
      "title2": "Uitzonderlijke klantondersteuning",
      "text2-1": "We begrijpen dat elke klant unieke behoeften heeft. Daarom staat ons meertalige verkoopteam klaar om persoonlijke en deskundige ondersteuning te bieden.",
      "title3": "Toewijding aan duurzame technologie",
      "text3-1": "Wij zetten ons in om wereldwijd toegang tot duurzame technologische oplossingen te bevorderen en ervoor te zorgen dat onze processen waarde creëren voor alle betrokken partijen.",
      "text3-2": "Voor meer informatie of om een proefbestelling te regelen, neem gerust contact met ons op. Ons team staat klaar om je met professionaliteit en zorg te helpen."
    }
  },
  "components": {
    "section2": {
      "646tj9dnkk00": "Ontvang snel je betaling in slechts 4 stappen",
      "s1": "Eerste stap",
      "s1t": "Verpak je toestel zorgvuldig, zodat het in dezelfde staat aankomt als waarin het is verzonden.",
      "s2": "Tweede stap",
      "s2t": "Lever je pakket in bij een van onze inleverpunten.",
      "s3": "Derde stap",
      "s3t": "We controleren je toestel en stellen een offerte voor je op.",
      "s4": "Vierde stap",
      "s4t": "Ontvang snel je betaling."
    },
    "section3": {
      "646tmse2fbo0": "Smartphones",
      "646tmse2mv00": "Blijf op de hoogte",
      "section3-text2": "Tablets",
      "section3-text4": "Horloges",
      "section3-text5": "Overige",
      "title": "Snelle waardeschatting",
      "t1": "Selecteer het type en start de waardebepaling voor een eerlijke offerte.",
      "t2": "Eenvoudige stappen — geniet van onze snelle recyclingservice!"
    },
    "section6": {
      "646txzpazuc0": "Over Danghuan",
      "666txzpazuc0": "Een bedrijf gespecialiseerd in de recycling en hergebruik van smartphones, tablets en andere digitale apparaten, gericht op een eenvoudig, veilig en efficiënt proces, zodat elke klant moeiteloos zijn oude toestel kan recyclen",
      "646txzpb0rk0": "Details",
      "646txzpb0xc0": "Recycling voor 12 merken"
    },
    "section7": {
      "646ns2k5f7k0": "Onze service is altijd beschikbaar",
      "646ns2k5gmw0": "Klantenservice: maandag t/m vrijdag van 9:00 tot 18:00 uur (CET), Madrid",
      "646ns2k5gs40": "Vul je naam in",
      "646ns2k5gx40": "Vul je telefoonnummer in",
      "646ns2k5img0": "Vul je e-mailadres in",
      "646ns2k5isw0": "Schrijf ons een bericht voordat wij contact met je opnemen",
      "646ns2k5iws0": "Neem contact met ons op",
      "646ns2k5j140": "Voer je telefoonnummer in",
      "646ns2k5j4g0": "Voer je e-mailadres in",
      "646ds2k5j4g0": "E-Mail",
      "646ns2k5j6c0": "Voer een geldig e-mailadres in",
      "646ns2k5j8g0": "Neem contact met ons op",
      "646ns2k5jak0": "C.I.F :",
      "646ns2k5jck0": "Adres",
      "646ns2s5jck0": "Calle del Hierro, 33, Planta 1 Nave 2, 28045 Madrid, Spanje",
      "646ns2k5jgc0": "Voer je naam in",
      "646ns2k5ji40": "Vink het vakje aan om akkoord te gaan met het privacybeleid",
      "646ns2k5jk00": "Inzending geslaagd",
      "646ns2k5jm80": "Inzending mislukt",
      "646ny1rgz3c0": "Ik heb gelezen en ga akkoord met de ",
      "646ny1rh2k40": "Privacyverklaring"
    },
    "successMain": {
      "647qmd42l1s0": "Bestelling succesvol ontvangen!",
      "647qmd42mss0": "Let op de verzendinstructies in de e-mail van no-reply@danghuan.eu. Controleer je spammap als je deze niet hebt ontvangen of neem contact op met insta360@danghuan.eu.",
      "647qmd42mz80": "Ons aanbod",
      "647qmd42yeo0": "Verzendingstips",
      "orderTime": "Besteltijd",
      "text1": "Gratis verzending",
      "text2": "Let op het verzenddocument dat naar je e-mail is gestuurd.",
      "text3": "Gegevens back-up",
      "text4": "Om je gegevens te beschermen, maak een back-up en verwijder alle gegevens of stel het apparaat opnieuw in.",
      "text5": "Opladen",
      "text6": "Laad je telefoon tot minstens 1% op voor verzending om de inspectie te versnellen.",
      "downloadDec": "Lataa rehellisyysvakuutus."
    },
    "tradeInProcess": {
      "649f8aefats0": "Order verlopen",
      "649f8aefc1c0": "Recycling mislukt",
      "649f8aefc9c0": "Ontvang een nieuwe offerte",
      "TradeIn": "Inruilproces",
      "logistic": "Download verzendlabel",
      "start": "Begin je traject",
      "success": "Je hebt het nieuwe toestel succesvol ontvangen",
      "qc": "Kwaliteitscontrole oud toestel",
      "business": "We ronden de inspectie van je oude toestel binnen 3 werkdagen af",
      "completed": "Voltooid",
      "successfully": "Gefeliciteerd, je inruil is succesvol afgerond",
      "orderInfor": "Bestelinformatie",
      "orderID": "Recycling ordernummer",
      "orderNum": "Order-ID van nieuwe aankoop",
      "createTime": "Aanmaakdatum",
      "brand": "Geschat merk",
      "model": "model",
      "price": "Waarde van oud toestel",
      "bonus": "Bonus",
      "total": "Totale prijs",
      "logisticInfo": "Logistieke informatie",
      "available": "Geen logistieke informatie beschikbaar",
      "logisticNum": "Logistiek nummer",
      "failRey": "Het spijt ons dat je deelname aan het OnePlus-recyclingprogramma niet succesvol is voltooid. Heb je plannen om andere elektronische apparaten te recyclen? Klik dan hieronder voor een snelle waardeschatting!",
      "userRes": "De gebruiker heeft het aanbod al geweigerd.",
      "successPrice": "De volgende prijs is vastgesteld na professionele inspectie. Als je akkoord gaat met deze prijs, wordt de inruil voortgezet. Als je weigert, wordt het toestel binnen enkele werkdagen naar je teruggestuurd.",
      "sure": "Accepteren",
      "Reject": "Weigeren",
      "congratulation": "Gefeliciteerd — geen verschil gevonden bij de kwaliteitscontrole.",
      "finPirce": "Eindprijs",
      "copySuccess": "Kopiëren geslaagd",
      "copyfail": "Kopiëren mislukt",
      "sureSuccess": "Bevestig geslaagde transactie",
      "submitError": "Inzending mislukt",
      "detectionResult": "Detectieresultaat",
      "Collected": "Ontvangen",
      "inTransit": "Onderweg / Verzending",
      "understand": "Ik begrijp het",
      '656g0lj3sf6e': 'Promotionele bonussen worden aangeboden en beheerd door de aangesloten merken. Ze worden apart uitbetaald en maken geen onderdeel uit van de waardebepaling van het oude toestel.'
    },
    "btnDialog": {
      "64a9shqq2ks0": "Weiger recycling",
      "64a9shqq3k00": "Je bevestigt dat je de recycling weigert",
      "64a9shqq3r00": "Annulering geslaagd",
      "64a9shqq3ws0": "Annulering mislukt",
      "sureCancel": "Bevestig annulering"
    }
  },
  "shippingLable": {
    "shippingLable": {
      "firstStep": "Persoonlijke informatie",
      "649fhwp9zbo0": "Upload een duidelijke foto van je pakket",
      "649fhwpa1900": "Download het verzendlabel",
      "649fhwpa1l00": "Download het verzendlabel",
      "649fhwpa1tc0": "Bezorging voltooid",
      "649fhwpa2100": "Pakketfoto en eerlijkheidsverklaring",
      "649fhwpa2880": "Voorbeeld van het aanbrengen van het verzendlabel",
      "649fhwpa2h80": "Opmerking",
      "649fhwpa2qk0": "Verpakking: Wikkel de telefoon in noppenfolie en vul de doos met krantenpapier om schade tijdens het transport te voorkomen.",
      "649fhwpa2xs0": "Vul open ruimtes op met beschermend materiaal om schade te voorkomen.",
      "649fhwpa3fk0": "Neem het digitale of gedrukte verzendlabel mee naar het inleverpunt; het officiële label wordt daar geprint.",
      "649fhwpa3v40": "Verzend je oude telefoon zo snel mogelijk. Als deze niet binnen 10 dagen is verzonden, wordt de bestelling geannuleerd.",
      "649fhwpa42s0": "Afhaalpunten opzoeken",
      "649fhwpa4as0": "Download het label",
      "649fhwpa4jo0": "Upload",
      "649fhwpa4ok0": "Startpagina",
      "649fhwpa4to0": "Succesvol ingediend",
      "649fhwpa4yk0": "Gefeliciteerd, download geslaagd!",
      "649fhwpasf3s": "Let op",
      "649fhwpaa6f3": "Print en onderteken de eerlijkheidsverklaring, maak een foto ervan samen met het pakket en upload deze."
    }
  },
  "bottom": {
    "index": {
      "646d51qugz40": "Sociale media",
      "646d71qugz40": "Eenvoudige betaling",
      "646u51qugz40": "Logistiek",
      "646u5dqui780": "Privacyverklaring",
      "646uddqui780": "Algemene voorwaarden",
      "646u51qui780": "FAQ's"
    }
  },
  "head": {
    "index": {
      "646nt7hwh0c0": "Over Danghuan",
      "646ntjwmn580": "Zakelijk",
      "646nt7hwils0": "Neem contact met ons op",
      "646nt7hwipg0": "Kopen",
      "646nt7hwis00": "Verkopen"
    }
  },
  "PCModelList": {
    "index": {
      "646wfv5g0ro0": "Gratis waardering"
    }
  },
  "PCSearch": {
    "index": {
      "646wgb1ni8k0": "Voer het model in dat je wilt verkopen",
      "646wgb1nj8o0": "搜索词",
      "646wgb1nji80": "我触发搜索上拉了",
      "empty": "Sorry, dit model bestaat niet",
      "confirm": "Bevestigen",
      "cancle": "Annuleren",
      "dialogText": "Weet je zeker dat je alle geschiedenis wilt verwijderen gegevens?"
    }
  },
  "PCProduct": {
    "empty": "Sorry, dit model bestaat niet"
  },
  "PCBrandTab": {
    "index": "Merk"
  },
  "PCCategoryTab": {
    "index": "Categorie"
  },
  "PCOrderStep": {
    "index": {
      "646xagqwff40": "Online bestellen",
      "646xagqwkuw0": "Gratis verzending",
      "646xagqwmao0": "Testen",
      "646xagqwmlc0": "Snelle betaling"
    }
  },
  "PCBreadNav": {
    "index": {
      "646xgup6ugg0": "Startpagina"
    }
  },
  "router": {
    "selectModel": "Modellen",
    "selectProperty": "Problemen met het toestel",
    "price": "Geschatte prijs",
    "priceOrder": "Plaats een bestelling",
    "orderSuccess": "Bestelling succesvol geplaatst"
  },
  "PCDeviceInfo": {
    "index": {
      "646ymq6orm00": "Kies het model opnieuw",
      "646ymq6ot0k0": "Herinnering",
      "646ymq6pd100": "Controleer vóór verzending of je bent uitgelogd bij het cloudaccount",
      "646ymq6pekw0": "/het schermslot en de Apple ID op het oude toestel."
    }
  },
  "PCModelInfo": {
    "index": {
      "646yn085ljk0": "Selecteer de staat van het toestel",
      "647h1f4yr6c0": "Geschatte prijs",
      "647h1f4yso80": "Geschatte bonus",
      "text1": "Gratis verzending",
      "text2": "Wij bieden gratis logistiek en verzending aan",
      "text3": "Directe betaling",
      "text4": "Wij maken de betaling binnen 3 werkdagen over zodra we je gebruikte toestel hebben ontvangen.",
      "64tve23zt0g0": "Gratis verzending en verkoopkit",
      "64tve23zup00": "Veilige gegevensverwijdering",
      "64tve23zuy40": "Niet tevreden? Gratis retourneren",
      "64tve23zv7g0": "De betaling wordt binnen 3 werkdagen geregeld na ontvangst van het toestel",
      "64tve23zvbg0": "Kies je verzendmethode",
      "64tve23zvf80": "Je hebt 10 dagen om je telefoon te verzenden.",
      "64tve23zvjc0": "Ontvang een gratis verzendlabel en stuur je telefoon op",
      "64tve23zvms0": "Ontvang het verzendlabel via e-mail",
      "64tve23zvqg0": "Opmerking:",
      "64tve23zvyo0": "Vanwege verzendbeperkingen met lithiumbatterijen mag je de telefoon niet verzenden als je vermoedt dat de batterij defect is.",
      "64tve23zwak0": "We kunnen geen accessoires of verpakkingen terugsturen die met het toestel zijn meegestuurd.",
      "64tve23zwgs0": "Volgende stappen om je telefoon te verkopen",
      "64tve23zwm80": "Vul je contactgegevens in",
      "64tve23zwt00": "Maak je telefoon klaar voor verzending",
      "64tve23zwwk0": "Je toestel wordt bij aankomst gecontroleerd. Als de informatie niet klopt, sturen we een nieuw aanbod. Je kunt dit accepteren of je toestel gratis terugkrijgen."
    }
  },
  "PCPropertyList": {
    "index": {
      "646ynp3udds0": "购买渠道",
      "646ynp3ueas0": "需要激活，无法正常通话",
      "646ynp3uehw0": "Voer het IMEI-nummer in",
      "646ynp3uem40": "Toets *#06# in op je toetsenbord om het IMEI-nummer te controleren"
    }
  },
  "PCButton": {
    "index": {
      "646zhxujd5g0": "Bekijk het aanbod"
    }
  },
  "PCBottomButton": {
    "index": {
      "647hqss75ac0": "Herinnering: De prijs kan tot 6% dalen, dus verstuur je pakket zo snel mogelijk.",
      "647hqss760c0": "Ik heb gelezen en ga akkoord met de",
      "647hqss764w0": "Privacybeleid",
      "647hqss76ac0": "Algemene voorwaarden",
      "647hqss76dg0": "Verzenden",
      "647hqss76gw0": "Totaal",
      "text1": "Totaal",
      "text2": "Geschatte prijs",
      "text3": "Geschatte bonus",
      "dialogTitle": "Opmerking",
      "dialogText": "Klik op BEVESTIG en controleer je e-mail om verder te gaan.",
      "dialogBtn": "BEVESTIG"
    }
  },
  "PCUserInfo": {
    "index": {
      "647kboa03ks0": "Bestelinformatie",
      "647kboa06ys0": "Naam",
      "647kboa0d6v8": "Landcode",
      "647kboa078s0": "Tel.",
      "647kboa07d00": "Adres",
      "647kboa07jk0": "Land",
      "647kboa07p80": "Selecteer alstublieft",
      "647kboa08b40": "Postcode",
      "647kboa08h00": "Stad",
      "647kboa08zc0": "Adres",
      "647kboa09440": "Bankgegevens",
      "647kboa096w0": "E-mailverificatie",
      "647kboa09ao0": "Email",
      "647kboa09dk0": "Verificatiecode",
      "647kboa09u40": "Invoeren",
      "647kboa09z80": "Verzenden",
      "647kboa0ak00": "Ongeldig e-mailindeling",
      "647kboa0aog0": "Succesvol verzonden",
      "send": "Verzonden",
      "submit": "Versturen",
      "error": "Verificatiecode fout",
      "64jjt96fg400": "Voer de verificatiecode in",
      "64jjt96fki00": "Vraag de code opnieuw aan",
      "idNumber": "ID-nummer / Identiteitsnummer",
      "declaration": "Verklaring van integriteit",
      "download": "downloaden",
      "647kboa0idc0": "Persoonlijk ID",
      "647kboa0idc1": "(het officiële identiteitsnummer dat door jouw land wordt uitgegeven en wordt gebruikt voor juridische, fiscale of administratieve doeleinden. Dit kan jouw DNI, NIE, Fiscaal identificatienummer, Persoonsnummer, CNP of een vergelijkbaar nationaal document zijn, afhankelijk van jouw woonland.)",
      "647kboa0idc2": "(het officiële identiteitsnummer dat door jouw land wordt uitgegeven en wordt gebruikt voor juridische, fiscale of administratieve doeleinden. Dit kan jouw DNI, NIE, Fiscaal identificatienummer, Persoonsnummer, CNP of een vergelijkbaar nationaal document zijn, afhankelijk van jouw woonland.)",
      "idError": "Ongeldig ID-nummer",
      "ibanTip": "Wordt gebruikt om de betaling voor het oude toestel te ontvangen.",
      "addreddPlaceholder": "Dit veld ondersteunt maximaal 105 tekens"
    }
  },
  "successOrder": {
    "successOrder": {
      "647s39cv77s0": "Startpagina",
      "notRecyclable": "Dit type toestel kan niet worden gerecycled",
      "IKnow": "Ik begrijp het",
      "tips": "Tips"
    }
  },

  "blog": {
    "blogList": {
      "64wgr171lsk0": "Weergaven",
      "64wgr171nq40": "Geen gerelateerde inhoud beschikbaar.",
      "64wgr171av65": "Datum"
    },
    "blogDetail": {
      "64wgr9y5r7s0": "Weergaven",
      "64wgr171wdx9": "Details"
    }
  },

  "cookieNotice": {
    "title": "Cookieverklaring",
    "description": "We gebruiken cookies om je ervaring te verbeteren. Door verder te gaan ga je akkoord met ons",
    "cookiePolicy": "cookiebeleid",
    "acceptAll": "Alle cookies accepteren",
    "acceptNecessary": "Alleen noodzakelijke cookies accepteren",
    "customize": {
      "title": "Selecteer de soorten cookies die je wilt accepteren:",
      "necessary": {
        "label": "Noodzakelijke cookies",
        "description": "Deze cookies zijn essentieel voor de werking van de website en kunnen niet worden uitgeschakeld."
      },
      "analytics": {
        "label": "Analysecookies",
        "description": "Deze cookies helpen ons te begrijpen hoe bezoekers met onze website omgaan."
      },
      "marketing": {
        "label": "Marketingcookies",
        "description": "Deze cookies volgen gebruikersactiviteit op verschillende websites om relevante advertenties te tonen."
      }
    },
    "save": "Instellingen opslaan",
    "cancel": "Annuleren"
  }
}